<template>
  <div>
    <Horizontal>
      <slot />
    </Horizontal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Horizontal from '@/views/layouts/Horizontal.vue'

export default {
  name: 'Layout',

  components: {
    Horizontal,
  },

  computed: {
    ...mapGetters(['layoutType']),
  },
}
</script>
